import { CreatedNotificationItem } from 'layout/inbox-notifications/close/reconciliation/task/CreatedNotificationItem';
import { DeletedNotificationItem } from 'layout/inbox-notifications/close/reconciliation/task/DeletedNotificationItem';
import { OverdueNotificationItem } from 'layout/inbox-notifications/close/reconciliation/task/OverdueNotificationItem';
import { StatusNotificationItem } from 'layout/inbox-notifications/close/reconciliation/task/StatusNotificationItem';
import { TemplateNotificationItem } from 'layout/inbox-notifications/close/reconciliation/task/TemplateNotificationItem';
import { UpdatedNotificationItem } from 'layout/inbox-notifications/close/reconciliation/task/UpdatedNotificationItem';
import { VarianceNotificationItem } from 'layout/inbox-notifications/close/reconciliation/task/VarianceNotificationItem';
import { CommentNotificationItem } from 'layout/inbox-notifications/close/reconciliation/task/comment/CommentNotificationItem';

import type {
  ReconciliationTaskNotification,
  ReconTaskCommentNotification,
  ReconTaskCreatedNotification,
  ReconTaskDeletedNotification,
  ReconTaskOverdueNotification,
  ReconTaskStatusNotification,
  ReconTaskTemplateNotification,
  ReconTaskUpdatedNotification,
  ReconTaskVarianceThresholdCrossedNotification,
} from 'types/inbox-notifications/close/ReconciliationNotifications';
import { SegmentAtByDot } from 'types/utils';

type TaskLevelKeys = SegmentAtByDot<ReconciliationTaskNotification['type'], 3>;

export function TaskNotificationItem({
  type,
  item,
}: {
  type: string[];
  item: ReconciliationTaskNotification;
}) {
  const [actionType, ...restOfType] = type;

  switch (actionType as TaskLevelKeys) {
    case 'created':
      return (
        <CreatedNotificationItem item={item as ReconTaskCreatedNotification} />
      );
    case 'updated':
      return (
        <UpdatedNotificationItem item={item as ReconTaskUpdatedNotification} />
      );
    case 'overdue':
      return (
        <OverdueNotificationItem item={item as ReconTaskOverdueNotification} />
      );
    case 'deleted':
      return (
        <DeletedNotificationItem item={item as ReconTaskDeletedNotification} />
      );

    case 'template':
      return (
        <TemplateNotificationItem
          item={item as ReconTaskTemplateNotification}
          type={restOfType}
        />
      );

    case 'variance':
      return (
        <VarianceNotificationItem
          item={item as ReconTaskVarianceThresholdCrossedNotification}
          type={restOfType}
        />
      );

    case 'status':
      return (
        <StatusNotificationItem
          item={item as ReconTaskStatusNotification}
          type={restOfType}
        />
      );

    case 'comment':
      return (
        <CommentNotificationItem
          item={item as ReconTaskCommentNotification}
          type={restOfType}
        />
      );

    default:
      return (
        <div>Unknown reconciliation task notification type: {actionType}</div>
      );
  }
}
